import React, { useEffect, useState } from 'react';
import { Box, Fab, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => 
      setVisible((window.scrollY || window.pageYOffset || 0) > 400);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={visible}>
      <Box
        sx={{
          position: 'fixed',
          bottom: { xs: 16, md: 24 },
          right: { xs: 16, md: 24 },
          zIndex: 1300,
        }}
      >
        <Fab
          size="small"
          color="default"
          onClick={handleClick}
          sx={{
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: 3,
            '&:hover': {
              bgcolor: 'grey.100',
            },
          }}
          aria-label="Revenir en haut de la page"
        >
          <KeyboardArrowUpIcon fontSize="small" />
        </Fab>
      </Box>
    </Zoom>
  );
};

export default ScrollToTopButton;
